// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 8C4 8.37 3.7 8.67 3.33 8.67C2.97 8.67 2.67 8.37 2.67 8C2.67 7.63 2.97 7.33 3.33 7.33C3.7 7.33 4 7.63 4 8Z',
  'M8.67 8C8.67 8.37 8.37 8.67 8 8.67C7.63 8.67 7.33 8.37 7.33 8C7.33 7.63 7.63 7.33 8 7.33C8.37 7.33 8.67 7.63 8.67 8Z',
  'M13.33 8C13.33 8.37 13.03 8.67 12.67 8.67C12.3 8.67 12 8.37 12 8C12 7.63 12.3 7.33 12.67 7.33C13.03 7.33 13.33 7.63 13.33 8Z',
];
